import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://yibrugfacepvrpmlshwe.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlpYnJ1Z2ZhY2VwdnJwbWxzaHdlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMwMTYwMTYsImV4cCI6MjA2ODU5MjAxNn0.nw-l7OtB8SBBy-_KxtDdm3i9GVLvsbLa9c7QVAMis8s';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);